import { KnowledgeBaseCategoryFragment } from "../../fragments/knowledge-base";
import { gql } from "@apollo/client";

export const QUERY_FETCH_KNOWLEDGE_BASE_PAGE = gql`
  query knowledgeBasePage {
    knowledgeBasePage {
      title
      description
      moreButtonTitle
      contentTemplateLabels {
        downloadableContentLabel
      }
    }
    knowledgeBaseCategories {
      ...KnowledgeBaseCategoryFragment
    }
  }
  ${KnowledgeBaseCategoryFragment}
`;
